<template>
  <div class="founder">
    <div class="founder-box">
      Zealcomm由<span>国际顶尖</span>的
      <br />
      网络音视频技术专家创立
    </div>
    <div class="container d-none d-lg-block">
      <div class="row">
        <div class="col-lg-6 col-md-12 col-sm-12 col-12">
          <div class="ceo-box">
            <div class="desc">
              <div class="txt-box">
                <p class="name">冯昶</p>
                <p>创始人 & CEO</p>
              </div>
              <img src="~assets/img/about/ceo.png" alt="" />
            </div>
            <div class="introduce" style="max-width: 422px">
              前美国&以色列视频公司CTO，打造了服务近2亿全球用户的视频PaaS和SaaS产品，提供每月超过十亿分钟的高清音视频通话云服务。
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-md-12 col-sm-12 col-12">
          <div class="cto-box dxd">
            <div class="desc">
              <div class="txt-box">
                <p class="name">段先德</p>
                <p>联合创始人 & CTO</p>
              </div>
              <img src="~assets/img/about/cto.png" alt="" />
            </div>
            <div class="introduce dxd">
              程序员、软件架构师 <br />
              Intel OWT(Open WebRTC Toolkit)项目首席作者
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container d-lg-none">
      <div class="row">
        <div class="col-lg-6 col-md-12 col-sm-12 col-12">
          <div class="ceo-box">
            <div class="introduce">
              前美国&以色列视频公司CTO
              <p>打造了服务近2亿全球用户的视频PaaS 和SaaS产品，提供每月超过十亿分钟的 高清音视频通话云服务。</p>
            </div>
            <div class="desc">
              <div class="txt-box">
                <p class="name">冯昶</p>
                <p>创始人 & CEO</p>
              </div>
              <img src="~assets/img/about/ceo-m.png" alt="" />
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-md-12 col-sm-12 col-12">
          <div class="cto-box">
            <div class="introduce">
              程序员、软件架构师 <br />
              Intel OWT(Open WebRTC Toolkit)项目首席作者
            </div>
            <div class="desc">
              <div class="txt-box">
                <p class="name">段先德</p>
                <p>联合创始人 & CTO</p>
              </div>
              <img src="~assets/img/about/cto-m.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props: {},
    data() {
      return {};
    },
    created() {},
    mounted() {},
    methods: {},
  };
</script>

<style lang="scss" scoped>
  %dxd {
    &::after {
      content: "";
      display: inline-block;
      margin-bottom: -10px;
      width: 100%;
      height: 6px;
      background: rgba(222, 243, 241, 1);
    }
  }

  .founder {
    overflow: hidden;
    background-color: #f5f5f7;

    .founder-box {
      margin-top: 100px;
      color: #333;
      font-size: 36px;
      text-align: center;

      span {
        color: $main-color;
      }
    }

    .container {
      margin-top: 86px;
      margin-bottom: 100px;
    }

    .ceo-box,
    .cto-box {
      padding: 20px 40px 40px;
      height: 100%;
      border-radius: 12px;
      box-shadow: 0 40px 30px rgba(178, 178, 178, 0.16);
      background-color: rgba(255, 255, 255, 1);

      .desc {
        @extend .flex-space-between;

        .txt-box {
          color: #333;
          font-size: 18px;

          .name {
            color: $minor-color;
            font-size: 30px;
            font-weight: bold;
          }
        }

        img {
          width: 96px;
        }
      }

      .introduce {
        margin-top: 30px;
        color: #333;
        font-size: 20px;
      }

      .introduce.dxd {
        @extend %dxd;
      }
    }
  }

  @media screen and (max-width: 992px) {
    .founder {
      .founder-box {
        margin-top: 50px;
        font-size: 18px;
      }

      .container {
        margin-top: 40px;
        margin-bottom: 50px;

        .row {
          > div {
            margin-bottom: 18px;
          }
        }
      }

      .ceo-box,
      .cto-box {
        padding: 16px 40px 25px;
        background-image: url("~assets/img/about/founder.png");
        background-repeat: no-repeat;
        background-position: 100% 0%;
        background-size: 70px 70px;

        .desc {
          margin-top: 20px;

          @extend .flex-space-between;

          .txt-box {
            color: #333;
            font-size: 12px;

            .name {
              color: #333;
              font-size: 18px;
              font-weight: bold;
            }
          }

          img {
            width: 70px;
          }
        }

        .introduce {
          margin-top: unset;
          width: 209px;
          color: #666;
          font-size: 12px;
          line-height: 23px;

          &::before {
            content: "";
            display: block;
            margin-bottom: 7px;
            width: 27px;
            height: 27px;
            background-image: url("~assets/img/about/boss-icon.png");
            background-repeat: no-repeat;
            background-size: 100% 100%;
          }
        }
      }
    }
  }
</style>
